/** @format */
import isPropValid from '@emotion/is-prop-valid';
import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

import { EmotionDynamicElement } from '@toucan/client/global/application';

import { ConstrainedWrapperSize, ConstrainedWrapperType } from './constants';
import { styles } from './constrained-wrapper.styles';
import {
    ConstrainedWrapperProps,
    StyledConstrainedWrapperProps,
} from './types';

export { getMaxWidthSize, getGutterSize } from './style-helpers';

export {
    ConstrainedWrapperGutter,
    ConstrainedWrapperSize,
    ConstrainedWrapperType,
} from './constants';

const StyledConstrainedWrapper = styled('div').withConfig({
    shouldForwardProp: (prop) => isPropValid(prop),
})<StyledConstrainedWrapperProps & EmotionDynamicElement>`
    ${styles}
`;

export const ConstrainedWrapper: FunctionComponent<ConstrainedWrapperProps> = ({
    children,
    as = 'div',
    type = ConstrainedWrapperType.GRID,
    size = ConstrainedWrapperSize.S_1248,
    gutter,
    ...otherProps
}: ConstrainedWrapperProps) => {
    return (
        <StyledConstrainedWrapper
            {...otherProps}
            type={type}
            as={as}
            gutter={gutter}
            size={size}
        >
            {children}
        </StyledConstrainedWrapper>
    );
};
